<template>
  <Toast />
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '550px' }"
    header="Gastos Operativos (Costos)"
    :modal="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-8">
          <span
            ><strong>GASTO OPERATIVO (COSTO): </strong>
            <span class="p-invalid">*</span></span
          >
          <div class="p-inputgroup">
            <Dropdown
              v-model="servicioSelect"
              :options="servicios"
              :filter="true"
              optionLabel="descripcion"
              placeholder="Seleccione un servicio..."
            >
              <template #option="slotProps">
                <span> {{ slotProps.option.descripcion }} </span>
              </template>
            </Dropdown>
            <Button
              class="p-button"
              v-if="'Servicio Crear' in auth.user.permissions"
              icon="pi pi-plus"
              v.tooltip.top="'Nuevo Servicio'"
              @click="activarServicioModal"
            />
          </div>
          <small class="p-invalid" v-if="errors.servicio_id">{{
            errors.servicio_id[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-4">
          <span
            ><strong>FECHA REGISTRO: </strong><span class="p-invalid">*</span>
          </span>
          <Calendar
            v-model="data_costo.fecha_registro"
            :showIcon="true"
            dateFormat="dd/mm/yy"
          />
          <small class="p-invalid" v-if="errors.fecha_registro">{{
            errors.fecha_registro[0]
          }}</small>
        </div>
        <div
          :class="
            enviar_a_banco ? 'field col-12 md:col-6' : 'field col-12 md:col-4'
          "
        >
          <div
            class="p-inputgroup"
            v-if="'Banco Listar' in auth.user.permissions"
          >
            <span class="p-inputgroup-addon">
              <span>DESDE BANCO:</span>
              <Checkbox
                v-model="enviar_a_banco"
                :binary="true"
                @change="cargarBancos"
                v-tooltip.top="'Enviar a Banco'"
              />
            </span>
            <Dropdown
              v-if="enviar_a_banco"
              v-model="bancoSelected"
              :options="bancos"
              optionLabel="descripcion"
              optionValue="id"
              placeholder="Seleccione la Caja Principal"
              :class="{ 'p-invalid': errors.bancoSelected }"
              @change="obtenerSaldoActual"
            >
              <template #option="slotProps">
                <span class="font-weight-bold">
                  {{ slotProps.option.numero_cuenta ?? "" }} -
                  {{ slotProps.option.descripcion ?? "" }}
                </span>
              </template>
            </Dropdown>
          </div>
        </div>
        <div class="field col-12 md:col-6" v-if="enviar_a_banco">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <span>MET. DE PAGO:</span>
            </span>
            <Dropdown
              v-model="metodo_pagoSelect"
              :options="metodo_pagos"
              optionLabel="nombre"
              optionValue="id"
            />
          </div>
        </div>
        <div class="field col-12 md:col-3">
          <span
            ><strong>EFECTIVO: </strong><span class="p-invalid">*</span></span
          >
          <InputNumber
            v-model="data_costo.costo"
            :minFractionDigits="2"
            mode="decimal"
            :inputClass="'text-right'"
            :min="0"
          >
          </InputNumber>
          <small class="p-invalid" v-if="errors.costo">{{
            errors.costo[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-3" v-if="metodo_pagoSelect != 1">
          <span><strong>TRANSFERENCIAS:</strong></span>
          <InputNumber
            v-model="monto_transferencia"
            :minFractionDigits="2"
            mode="decimal"
            showButtons
            :inputClass="'text-right'"
            :min="0"
          />
        </div>

        <div
          :class="
            this.metodo_pagoSelect == 1
              ? 'field col-12 md:col-9'
              : 'field col-12 md:col-6'
          "
        >
          <span><strong>OBSERVACI&Oacute;N: </strong></span>
          <Textarea
            v-model.trim="data_costo.observacion"
            rows="1"
            autoResize
            placeholder="Ingrese una observacion..."
          />
          <small class="p-invalid" v-if="errors.observacion">{{
            errors.observacion[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-12" v-show="data_costo.id">
          <span><strong>ESTADO: </strong><span class="p-invalid">*</span></span>
          <Dropdown
            v-model="data_costo.estado"
            :options="estados"
            optionLabel="label"
            placeholder="Seleccione un estado..."
          >
            <template #value="slotProps">
              <span
                :class="'product-badge ' + claseEstado[slotProps.value.value]"
              >
                {{ slotProps.value.label }}
              </span>
            </template>
          </Dropdown>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="field">
        <span class="flex md:justify-content-start"
          ><strong>CAMPOS REQUERIDOS: </strong>
          <span class="p-invalid">*</span></span
        >
      </div>
      <Button
        label="CANCELAR"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="ocultarDialog"
      />
      <Button
        :label="data_costo.id ? 'ACTUALIZAR' : 'GUARDAR'"
        icon="pi pi-save"
        class="p-button-info p-button-lg"
        @click="saveCosto"
        :loading="enviado"
      />
    </template>
  </Dialog>
  <ServicioCreate
    :show="servicioModal"
    :servicio="servicio"
    @closeModal="cerrarModalServicio"
    @actualizarListado="cargarServicios"
  ></ServicioCreate>
</template>
<script>
import CostoService from "@/service/CostoService";
import ServicioService from "@/service/ServicioService";
import ServicioCreate from "@/module/servicios/ServicioCreate.vue";
import { useAuth } from "@/stores";
import BancoService from "@/service/BancoService";
import MetodoPagoService from "@/service/MetodoPagoService.js";

export default {
  components: {
    ServicioCreate,
  },
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    costo: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      mostrarModal: this.show,
      data_costo: this.costo,
      enviado: false,
      estados: [
        { label: "INACTIVO", value: 0 },
        { label: "ACTIVO", value: 1 },
      ],
      errors: {},
      claseEstado: ["status-outofstock", "status-instock"],
      servicios: [],
      servicioSelect: null,
      servicioModal: false,
      servicio: { estado: { label: "ACTIVO", value: 1 } },
      bancoSelected: null,
      bancos: [],
      enviar_a_banco: false,
      metodo_pagoSelect: 1,
      metodo_pagos: [],
      monto_transferencia: 0,
      saldo_actual: 0,
      nombre_servicio: "",
    };
  },
  costoService: null,
  servicioService: null,
  bancoService: null,
  metodoPagoService: null,

  auth: null,
  created() {
    this.costoService = new CostoService();
    this.servicioService = new ServicioService();
    this.auth = useAuth();
    this.bancoService = new BancoService();
    this.metodoPagoService = new MetodoPagoService();
  },

  mounted() {
    this.cargarServicios();
    this.getMetodoPagos();
  },
  methods: {
    obtenerSaldoActual() {
      this.bancos.forEach((element) => {
        if (element.id == this.bancoSelected) {
          this.saldo_actual = element.saldo_actual;
        }
      });
    },
    getMetodoPagos() {
      this.metodoPagoService.getAllMetodoPagos().then((response) => {
        this.metodo_pagos = response.metodo_pagos;
      });
    },
    cargarBancos() {
      this.bancoService.getBancosAll().then((data) => {
        this.bancos = data.bancos;
      });
    },
    activarServicioModal() {
      this.servicioModal = true;
      this.servicio = {
        estado: { label: "ACTIVO", value: 1 },
      };
    },
    cerrarModalServicio() {
      this.servicioModal = false;
      this.servicio = {};
      this.servicioSelect = {};
    },
    ocultarDialog() {
      this.errors = {};
      this.mostrarModal = false;
      this.data_costo = {};
      this.servicioSelect = null;
      this.monto_transferencia = 0;
      this.bancoSelected = null;
      this.metodo_pagoSelect = 1;
      this.enviar_a_banco = false;
      this.enviado = false;
      this.nombre_servicio = "";

      this.$emit("closeModal");
    },
    validarFormulario() {
      this.errors = {};
      if (this.servicioSelect == null) {
        this.errors.servicio_id = ["El campo Servicio es requerido"];
      }
      if (this.data_costo.fecha_registro == null) {
        this.errors.fecha_registro = ["El campo Fecha es requerido"];
      }
      if (this.data_costo.costo == null) {
        this.errors.costo = ["El campo Monto es requerido"];
      }
      if (this.metodo_pagoSelect == 1 && this.monto_efectivo == 0) {
        this.errors.monto_efectivo = ["El campo Monto es requerido"];
      }
      if (this.metodo_pagoSelect != 1 && this.monto_transferencia == 0) {
        this.errors.monto_transferencia = ["El campo Monto es requerido"];
      }
      if (this.enviar_a_banco && this.bancoSelected == null) {
        this.errors.bancoSelected = ["El campo Banco es requerido"];
      }
      return Object.keys(this.errors).length == 0;
    },
    saveCosto() {
      if (!this.validarFormulario()) {
        return;
      }

      this.errors = {};
      this.enviado = true;
      if (this.costo.id) {
        let costo_enviar = {
          ...this.data_costo,
          estado: this.data_costo.estado.value,
          servicio_id: this.servicioSelect.id ?? null,
          monto_transferencia: this.monto_transferencia,
          nombre_servicio: this.servicioSelect.descripcion,
        };
        this.costoService.updatedCosto(costo_enviar).then((data) => {
          if (Object.prototype.hasOwnProperty.call(data, "errors")) {
            this.errors = data.errors;
          } else {
            this.errors = {};
            this.$toast.add({
              severity: "success",
              summary: "Exito!",
              detail: data.mensaje,
              life: 3000,
            });
            this.$emit("actualizarListado");
            this.ocultarDialog();
          }
          this.enviado = false;
        });
      } else {
        let tmp = this.data_costo;
        this.data_costo = {
          ...this.data_costo,
          estado: this.data_costo.estado.value,
          servicio_id: this.servicioSelect.id ?? null,
          monto_transferencia: this.monto_transferencia ?? 0,
          banco_id: this.bancoSelected,
          saldo_actual: this.saldo_actual,
          metodo_pago_id: this.metodo_pagoSelect,
          nombre_servicio: this.servicioSelect.descripcion,
        };
        this.costoService.saveCosto(this.data_costo).then((data) => {
          if (Object.prototype.hasOwnProperty.call(data, "errors")) {
            this.errors = data.errors;
            this.data_costo = tmp;
          } else {
            this.errors = {};
            this.$toast.add({
              severity: "success",
              summary: "Exito!",
              detail: data.mensaje,
              life: 10000,
            });
            this.$emit("actualizarListado");
            this.ocultarDialog();
          }
          this.enviado = false;
        });
      }
    },
    cargarServicios(servicio = null) {
      this.servicioService
        .getServiciosAll()
        .then((response) => {
          this.servicios = response.servicios ?? [];
          if (servicio) {
            this.servicios.forEach((element) => {
              if (element.id == servicio.id) {
                this.servicioSelect = element;
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  watch: {
    show(val) {
      this.mostrarModal = val;
    },
    costo(val) {
      this.data_costo = val;
      if (this.data_costo.id == null) {
        this.data_costo.fecha_registro = new Date();
        return;
      }
      this.servicioSelect = this.servicios.find(
        (servicio) => servicio.id == this.data_costo.servicio_id ?? null
      );
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
.p-inputgroup-addon {
  background-color: #ffffff;
  font-weight: bold;
  color: #000000;
  border: none;
}
</style>
